import { render, staticRenderFns } from "./FormAuthorityConfig.vue?vue&type=template&id=7f997328&scoped=true"
import script from "./FormAuthorityConfig.vue?vue&type=script&lang=js"
export * from "./FormAuthorityConfig.vue?vue&type=script&lang=js"
import style0 from "./FormAuthorityConfig.vue?vue&type=style&index=0&id=7f997328&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f997328",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f997328')) {
      api.createRecord('7f997328', component.options)
    } else {
      api.reload('7f997328', component.options)
    }
    module.hot.accept("./FormAuthorityConfig.vue?vue&type=template&id=7f997328&scoped=true", function () {
      api.rerender('7f997328', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/common/process/config/FormAuthorityConfig.vue"
export default component.exports